import { BoxSkeleton, Stack } from '@common-components';

export function AIResponseMessageSkeleton() {
  return (
    <Stack direction="column" gap={1.5} sx={{ mt: 2 }}>
      <BoxSkeleton index={0} sx={{ width: 0.9, height: 20 }} isLoading />
      <BoxSkeleton index={1} sx={{ width: 0.75, height: 20 }} isLoading />
      <BoxSkeleton index={2} sx={{ width: 0.85, height: 20 }} isLoading />
      <BoxSkeleton index={3} sx={{ width: 0.65, height: 20 }} isLoading />
    </Stack>
  );
}
